import React, { useEffect, useState } from "react";
import "./ChartModal.css";

import {
  TransformWrapper,
  TransformComponent
} from "react-zoom-pan-pinch";

import { Document, Page, pdfjs } from "react-pdf";

import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc =
  `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function ChartModal({
  chart,
  onClose,
  onSave,
  onUnsave,
  savedCharts = []
}) {

  console.log(
  "CHARTMODAL SIZE:",
  chart.width,
  chart.height
);

  const [numPages, setNumPages] = useState(null);

  const [pageNumber, setPageNumber] =
    useState(1);

  const [rotation, setRotation] =
    useState(0);



  useEffect(() => {

    const handleKeyDown = (e) => {

      if (e.key === "Escape") {
        onClose();
      }

      if (e.key === "ArrowRight") {
        setPageNumber((p) =>
          Math.min(
            p + 1,
            numPages || 1
          )
        );
      }

      if (e.key === "ArrowLeft") {
        setPageNumber((p) =>
          Math.max(
            p - 1,
            1
          )
        );
      }

    };

    window.addEventListener(
      "keydown",
      handleKeyDown
    );

    return () =>
      window.removeEventListener(
        "keydown",
        handleKeyDown
      );

  }, [onClose, numPages]);

  if (!chart) return null;

  const isSaved =
    savedCharts.some(
      (c) => c.url === chart.url
    );

  const handleToggleSave = () => {

    if (isSaved) {
      onUnsave(chart);
    } else {
      onSave(chart);
    }
  };

  const pdfUrl =
    `https://ficon-x.com/route/chart_proxy?url=${encodeURIComponent(chart.url)}`;

return (

  <div
    style={{
        width: "100%",
        height: "100%",
        background:
          "rgba(20,20,20,0.98)",
        borderRadius: "14px",
        overflow: "hidden",
        border:
          "1px solid rgba(255,255,255,0.15)",
        boxShadow:
          "0 0 35px rgba(0,0,0,0.6)",
        display: "flex",
        flexDirection: "column",
        pointerEvents: "auto"
      }}
    >

      {/* HEADER */}

<div
  className="chart-drag-handle"
  style={{
    padding: "10px 14px",
    minHeight: 50,
    background: "rgba(255,255,255,0.08)",
    color: "white",

    display: "flex",

    width: "100%",

    minWidth: 0,

    boxSizing: "border-box",

    justifyContent: "space-between",

    alignItems: "center",

    cursor: "move",

    fontWeight: 600
  }}
>
<div
  style={{
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",

    flex: 1,

    minWidth: 0
  }}
>
          📑 {chart.name}
        </div>

<div
  style={{
    display: "flex",

    gap: 6,

    flexShrink: 0
  }}
>

          {/* PAGE */}

          <button
            onClick={() =>
              setPageNumber((p) =>
                Math.max(
                  p - 1,
                  1
                )
              )
            }
          >
            ◀
          </button>

          <button
            onClick={() =>
              setPageNumber((p) =>
                Math.min(
                  p + 1,
                  numPages || 1
                )
              )
            }
          >
            ▶
          </button>



          {/* ROTATE */}

          <button
            onClick={() =>
              setRotation(
                (r) => r - 90
              )
            }
          >
            ↺
          </button>

          <button
            onClick={() =>
              setRotation(
                (r) => r + 90
              )
            }
          >
            ↻
          </button>

          {/* SAVE */}

          <button
            onClick={
              handleToggleSave
            }
            style={{
              background:
                isSaved
                  ? "#2e7d32"
                  : "#1976d2",
              color: "white"
            }}
          >
            {isSaved
              ? "Saved"
              : "Save"}
          </button>

          {/* CLOSE */}

          <button
            onClick={onClose}
            style={{
              background:
                "#d32f2f",
              color: "white"
            }}
          >
            ✕
          </button>

        </div>

      </div>
{/* PDF VIEWER */}

<div
  style={{
    flex: 1,
    background: "#111",
    overflow: "hidden",
    position: "relative"
  }}
>

  <TransformWrapper
    initialScale={.4}
    minScale={0.30}
    maxScale={8}

    wheel={{
      step: 0.005
    }}

    pinch={{
      step: 1
    }}

    doubleClick={{
      disabled: true
    }}

    centerOnInit={true}

    limitToBounds={false}
  >

<TransformComponent
  wrapperStyle={{
    width: "100%",
    height: "100%"
  }}

  contentStyle={{
    width: "100%",
    height: "100%",

    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }}
>

  <div
    style={{
      padding: 20,

      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      transform: "translateY(-600px)"
    }}
  >

        <Document
          file={pdfUrl}

          onLoadSuccess={({ numPages }) =>
            setNumPages(numPages)
          }

          loading={
            <div
              style={{
                color: "white"
              }}
            >
              Loading PDF...
            </div>
          }
        >

          <Page
            pageNumber={pageNumber}

            width={1800}

            rotate={rotation}

            renderTextLayer={false}

            renderAnnotationLayer={false}
          />

        </Document>

      </div>

    </TransformComponent>

  </TransformWrapper>

</div>

    </div>

  );

}